/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import {
  IButtonStyles,
  IMessageBarStyleProps,
  IMessageBarStyles,
  IStyleFunctionOrObject,
} from "@fluentui/react";

export const uploadDeclineDialogStyle = {
  minWidth: "450px !important",
  "@media screen and (min-width: 320px) and (max-width: 766px)": {
    minWidth: "200px !important",
  },
};

export const uploadedFileButtonStyle: IButtonStyles = {
  flexContainer: {
    marginLeft: -10,
  },
};

export const messageBarStyle: IStyleFunctionOrObject<
  IMessageBarStyleProps,
  IMessageBarStyles
> = {
  content: {
    fontSize: 14,
  },
  text: {
    fontSize: 14,
  },
};
